<script setup>
import VerifyEmail from "@/components/parent/VerifyEmail.vue";
</script>

<template>
  <VerifyEmail />
</template>
